import { render, staticRenderFns } from "./PageDetail.vue?vue&type=template&id=6aeb6ef7&scoped=true"
import script from "./PageDetail.vue?vue&type=script&lang=js"
export * from "./PageDetail.vue?vue&type=script&lang=js"
import style0 from "./PageDetail.vue?vue&type=style&index=0&id=6aeb6ef7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aeb6ef7",
  null
  
)

export default component.exports